import { WS_DESTINATION_PREFIX } from '@1po/1po-bff-fe-spec/generated/common/WebsocketConstants';
import { Client } from '@stomp/stompjs';
import { WebSocketAction } from 'utils/domainStore';

export const sendTrackingMessage = (stompClient: Client | null, request: WebSocketAction): void => {
  if (!stompClient) {
    console.error('stompClient was not initialized');
    return;
  }

  const { traceId, payload, url } = request;
  const data = JSON.stringify(payload);
  const destination = WS_DESTINATION_PREFIX + url;

  try {
    stompClient.publish({
      destination,
      body: data,
      headers: {
        'trace-id': traceId,
      },
    });
  } catch (e) {
    console.error(`Error observed during stomp client publish. Unable to send data to ${url} with data ${data}`, e);
  }
};
